import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { Directive, forwardRef, OnInit } from '@angular/core';

import { ofLegalAge } from './validator';

@Directive({
    selector: '[ofLegalAge][formControlName],[ofLegalAge][formControl],[ofLegalAge][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => OfLegalAgeDirective),
            multi: true,
        },
    ],
})
export class OfLegalAgeDirective implements Validator, OnInit {
    private validator: ValidatorFn;

    ngOnInit() {
        this.validator = ofLegalAge();
    }

    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c);
    }
}
